module.exports = __webpack_public_path__ + "static/media/70Hou@4x.4bda02ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/70Hou@4x.png
// module id = 1685
// module chunks = 0 1